module.exports = __webpack_public_path__ + "static/media/costcase4.aa9954b7.png";